import {CustomTextArea} from "../CustomTextArea";
import React, {FC} from "react";
import {ITextArea} from "./types";
import cls from '../atoms.module.scss'

const TextArea: FC<ITextArea> = ({
                                     item,
                                     index,
                                     savedFormData,
                                     translationsData,
                                     handleChange
                                 }) => (
    <div key={index} className={cls["signUp-position-relative"]}>
        <CustomTextArea
            name={item.attribute_code}
            inpValue={(savedFormData as Record<string, string>)?.[item.attribute_code]}
            handleChange={(e) => handleChange(e as any, item.validation)}
            value={translationsData[item.default_label]}
            label={item.default_label}
            required={!!+item.is_required}
            custom={true}
        />
    </div>
)

export default TextArea